const selectCompanyStep = {
  title: "Select your company",
  addCompany: {
    thanks: "Thanks for your interest in the partner program.",
    subsidiaryQuestion:
      "Based on the email domain you entered, it looks like you need to register your company. Is your company a subsidiary of another company or a distinct company of its own?",
    feeNote:
      "Please note that depending on your selection, membership fees may apply.",
  },
  companyList: {
    prompt: "Are you associated with one of these companies?",
    continuePrefix: "Continue ",
    continueLink: "here",
    continueSuffix: " to register a new company.",
  },
} as const;

export type SelectCompanyStepContent = typeof selectCompanyStep;
export default selectCompanyStep;
